










































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ImportFromServiceResponse } from '@/types/course.type';
import ServiceCoursesTablesComponent from './serviceCoursesTables.component.vue';

@Component({
  components: {
    ServiceCoursesTablesComponent,
  },
})
export default class ServiceCoursesDetailsComponent extends Vue {
  @Prop(Object) readonly data!: ImportFromServiceResponse;

  get hasFoundationsCourses(): boolean {
    return !!this.data.foundationsCourses;
  }
}
